import React from 'react';
import styled from 'styled-components';

interface ComponentProps {
  columns?: Column[];
  renderers: RenderFunction[];
  data: any[];
  expandedRows?: any[];
  onRowToggle?: (row: any) => void;
  rowExpansionTemplate?: (row: any) => JSX.Element;
  className?: string;
}

interface Column {
  name: string;
  width?: string;
}

type RenderFunction = (row: any, index: number) => JSX.Element;

/**
 * @deprecated Use `src/components/RingilDataTable/RingilDataTable.tsx` instead.
 */
const RingilDataTable: React.FC<ComponentProps> = ({ columns, className, renderers, data, expandedRows = [], onRowToggle, rowExpansionTemplate }) => {
  return (
    <Table className={className}>
      <Thead>
        <Tr>
          {columns.map((col, colIndex) => {
            return (
              <Th key={colIndex} style={col.width ? { width: col.width } : undefined}>
                <ColName>{col.name}</ColName>
              </Th>
            );
          })}
        </Tr>
      </Thead>
      <Tbody>
        {data.map((item, itemIndex) => {
          const isExpanded = expandedRows.includes(item);
          return (
            <React.Fragment key={itemIndex}>
              <Tr>
                {renderers?.map((renderer, rendererIndex) => {
                  return <Td key={rendererIndex}>{renderer(item, itemIndex)}</Td>;
                })}
              </Tr>
              {isExpanded && rowExpansionTemplate && (
                <Tr>
                  <Td colSpan={renderers.length}>{rowExpansionTemplate(item)}</Td>
                </Tr>
              )}
            </React.Fragment>
          );
        })}
      </Tbody>
    </Table>
  );
};

const ColName = styled.div`
  font-weight: bold;
  margin-bottom: 0;
`;

const Table = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-radius: 10px; /* Nastaví zaoblené rohy tabulky */
  overflow: auto; /* Zajistí, že obsah tabulky nebude přesahovat zaoblené rohy */
  font-family: 'DM Sans', sans-serif;
`;

const Th = styled.th`
  text-align: left;
  padding: 1rem 1rem;

  div {
    font-weight: 500;
    color: #343333 !important;
    font-family: 'DM Sans', sans-serif !important;
  }

  :first-child {
    border-top-left-radius: 10px; /* Zaoblený levý horní roh */
  }

  :last-child {
    border-top-right-radius: 10px; /* Zaoblený pravý horní roh */
  }
`;

const Td = styled.td`
  background-color: white;
  font-family: 'DM Sans', sans-serif;
`;

const Tr = styled.tr`
  background-color: white;

  ${Td} {
    padding: 2rem 1rem;
  }

  :last-child td:first-child {
    border-bottom-left-radius: 10px; /* Zaoblený levý spodní roh */
  }

  :last-child td:last-child {
    border-bottom-right-radius: 10px; /* Zaoblený pravý spodní roh */
  }
`;

const Tbody = styled.tbody``;

const Thead = styled.thead`
  ${Tr} {
    background-color: var(--ringil3-content-quaternary);
  }
`;

export default RingilDataTable;
